import { requestPaymentsUrl, requestPaymentsUrlBod } from '../services/payments.service';

const ARP_REQUEST_PAYMENT_BY_CARD = 'ARP_REQUEST_PAY_BY_CARD';
const PAYMENT_BY_CARD_REQUESTED = 'PAYMENT_BY_CARD_REQUESTED';
const ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL = 'ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL';
const BOD_REQUEST_PAYMENT_BY_CARD = 'BOD_REQUEST_PAYMENT_BY_CARD'
const BOD_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL = 'BOD_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL'

const events = [
  ARP_REQUEST_PAYMENT_BY_CARD,
  PAYMENT_BY_CARD_REQUESTED,
  ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL,
  BOD_REQUEST_PAYMENT_BY_CARD,
  BOD_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL,
];

const initializeEventListeners = () => {
  EVENT_BUS.registerEvents(events);

  EVENT_BUS.on(
    ARP_REQUEST_PAYMENT_BY_CARD,
    ({ auctionId, csrfToken, propertiesIds }) => {
      const onError = (err) => {
        console.warn(err);
        EVENT_BUS.dispatch(ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL, {});
      }
      const displayStatus = (response) => {
        const acceptedStatuses = [201];
        const paymentUrl = response.data['payment_url'];
        if (acceptedStatuses.includes(response.status)) {
          EVENT_BUS.dispatch(PAYMENT_BY_CARD_REQUESTED, {
            paymentUrl,
          });
        }else{
          EVENT_BUS.dispatch(ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL, {});
        }
      };
      requestPaymentsUrl({
        auctionId,
        csrfToken,
        propertiesIds,
        onResponse: displayStatus,
        onError,
      });
    }
  );

  EVENT_BUS.on(
    BOD_REQUEST_PAYMENT_BY_CARD,
    ({ bidderId, csrfToken }) => {
      const onError = (err) => console.warn(err);
      const displayStatus = (response) => {
        const acceptedStatuses = [201];
        const paymentUrl = response.data['payment_url'];
        if (acceptedStatuses.includes(response.status)) {
          EVENT_BUS.dispatch(PAYMENT_BY_CARD_REQUESTED, {
            paymentUrl,
          });
        }else{
          EVENT_BUS.dispatch(BOD_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL, {});
        }
      };
      requestPaymentsUrlBod({
        bidderId,
        csrfToken,
        onResponse: displayStatus,
        onError,
      });
    }
  );

  EVENT_BUS.on(PAYMENT_BY_CARD_REQUESTED, ({ paymentUrl }) => {
    window.open(paymentUrl, '_self');
  });
};

export const PAY_BY_CARD_EVENTS = {
  ARP_REQUEST_PAYMENT_BY_CARD,
  PAYMENT_BY_CARD_REQUESTED,
  ARP_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL,
  BOD_REQUEST_PAYMENT_BY_CARD,
  BOD_PAYMENT_BY_CARD_REQUEST_UNSUCCESSFUL,
  initializeEventListeners,
};
